import React, { useState, useEffect } from 'react'

import { Button, Dialog, Grid, Icon, Typography, FormHelperText } from '@material-ui/core'

import Scrollbars from "rc-scrollbars";
import CloseIcon from '@material-ui/icons/Close';
import { DraggableComponent } from '../../../../../../components/UiElements/UiElements';
import RichTextEditor from 'react-rte';

import useStyles from "./styles";

function AddEditDetails({ dialogOpenClose, handleClose, ...props }) {
    const classes = useStyles();
    const [editorValue, setEditorValue] = useState(RichTextEditor.createValueFromString("", 'html'));

    const handleEditorChange = (editorValue) => {
        setEditorValue(editorValue);
    }

    return (
        <Dialog
            classes={{ paper: classes.dialogPaper }}
            disableEscapeKeyDown
            open={dialogOpenClose}
            PaperComponent={DraggableComponent}
            maxWidth="lg"
            {...props} >

            <div className={classes.dialogContent}>
                <div className={classes.box}>

                    <div className={classes.header} id="draggable-dialog-title">
                        <Typography className={classes.title}>Add Content</Typography>
                        <Icon className={classes.closeIcon} onClick={handleClose} color="primary"><CloseIcon /></Icon>
                    </div>

                    <div className={classes.content}>
                      
                        <Scrollbars autoHeight autoHeightMin={220} autoHeightMax={550}>

                            <Grid item lg={12}>
                                <RichTextEditor
                                    value={editorValue}
                                    onChange={handleEditorChange}
                                    className={classes.note}
                                    placeholder="Enter Notes"
                                >
                                </RichTextEditor>
                            </Grid>

                        </Scrollbars>

                    </div>

                </div>
            </div>
        </Dialog>
    )
}
export default AddEditDetails;